import loadForm3 from './loadForm3'
import unloadForm3 from './unloadForm3'
import saveForm3 from './saveForm3'
import changeStatus3 from './changeStatus3'
import requestForm3Section from './requestForm3Section'
import addNote3 from './addNote3'
import uploadv3 from './uploadv3'
import initUploadv3 from './initUploadv3'
import streamUploadv3 from './streamUploadv3'
import finishUploadv3 from './finishUploadv3'
import requestChangeStatus3 from './requestChangeStatus3'
// import resetIds from './resetIds'

const form3 = {
    loadForm3,
    unloadForm3,
    saveForm3,
    changeStatus3,
    requestForm3Section,
    addNote3,
    uploadv3,
    initUploadv3,
    streamUploadv3,
    finishUploadv3,
    requestChangeStatus3,
    // resetIds
};

export default form3